import {
    useEffect,
    type FC,
    useId
} from "react";
import type IInputGroupTextProps from "./type";
import stylesheet, {
    getInputGroupTextColor
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    useInputGroupAddonContext,
    useInputGroupContext
} from "../../context";
import Text from "../../../text";

const InputGroupText: FC<IInputGroupTextProps> = ({
    customColor,
    customTheme,
    children,
    style,
    ...props
}) => {
    const {
        customTheme: groupCustomTheme,
        unregisterText,
        registerText,
        currentSize,
        isDisabled
    } = useInputGroupContext();

    const addonContext = useInputGroupAddonContext();

    const currentTheme = customTheme ?? groupCustomTheme;

    const {
        colors
    } = NCoreUIKitTheme.useContext(currentTheme);

    const generatedID = useId();

    const textID = props.id ?? generatedID;

    const isTextContent = typeof children === "string" || typeof children === "number";

    useEffect(() => {
        registerText({
            text: isTextContent ? String(children) : undefined,
            id: textID
        });

        return () => {
            unregisterText(textID);
        };
    }, [
        isTextContent,
        children,
        textID
    ]);

    return <Text
        {...props}
        customColor={customColor ?? getInputGroupTextColor({
            isAttached: addonContext?.variant === "attached",
            isDisabled,
            colors
        })}
        variant={currentSize.valueVariant}
        customTheme={currentTheme}
        style={[
            style,
            stylesheet.text
        ]}
        id={textID}
    >
        {children}
    </Text>;
};
export default InputGroupText;
